<div class="grid grid-gutter-32 grid-column">
  <!--<a
    *ngIf="nomenclature.kbNomenclatureInfo.containerUrl"
    [href]="nomenclature.kbNomenclatureInfo.containerUrl"
    target="_blank"
    class="alert alert-info alert-primary full-width "
  >
    <div class="alert-content">
      <div class="alert-title">Приём биоматериала осуществляется в специальном контейнере!</div>
      <div class="alert-message">Приобрести контейнер можно заранее в ближайшем центре Helix</div>
    </div>
  </a>-->
  <div
    class="grid-item"
    *ngIf="(repository.nomenclature$ | async)?.attributes?.anonymousForbidden"
  >
    <div class="alert alert-info alert-primary mb">
      <div class="alert-content">
        <div class="alert-title typography typography-paragraph">
          Анализ не выполняется анонимно, необходимо предъявить паспорт и СНИЛС.
        </div>
        <div class="alert-message">
          Информируем вас о том, что в соответствии с п. 2.4. Постановления
          Главного государственного санитарного врача РФ от 13.03.2020 № 6 «О
          дополнительных мерах по снижению рисков распространения COVID-2019»
          при положительном результате исследования на COVID-2019 данные будут
          направляться в Роспотребнадзор.
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      (repository.nomenclature$ | async)?.kbNomenclatureInfo?.shortDescription
    "
    class="grid-item"
  >
    <div
      class="typography typography-medium typography-paragraph"
      style="font-size: 1.25rem"
    >
      Описание
    </div>

    <div
      *ngIf="((repository.nomenclature$ | async)?.testSystems?.length ?? 0) > 0"
      class="mb-28"
    >
      <app-test-systems
        [items]="(repository.nomenclature$ | async)?.testSystems ?? []"
      ></app-test-systems>
    </div>

    <div
      class="typography typography-headline grey-800"
      [innerHtml]="
        (repository.nomenclature$ | async)?.kbNomenclatureInfo
          ?.shortDescription ?? '' | safeHtml
      "
    ></div>

    <div
      *ngIf="
        (repository.nomenclature$ | async)?.nomenclatureInfo?.russianSynonyms ||
        (repository.nomenclature$ | async)?.nomenclatureInfo?.englishSynonyms
      "
    >
      <div class="divider grid-item"></div>

      <div class="grid-item">
        <div class="grid">
          <div class="grid-item">
            <div class="grid grid-gutter-8">
              <div class="grid-item">
                <div
                  class="typography typography-body typography-medium grey-300"
                >
                  Синонимы
                </div>
              </div>
              <div class="grid-item">
                <div class="typography grey-300">
                  {{
                    (repository.nomenclature$ | async)?.nomenclatureInfo
                      ?.russianSynonyms
                  }}
                  <ng-template
                    *ngIf="
                      (repository.nomenclature$ | async)?.nomenclatureInfo
                        ?.russianSynonyms &&
                      (repository.nomenclature$ | async)?.nomenclatureInfo
                        ?.englishSynonyms
                    "
                  >
                    /
                  </ng-template>
                  {{
                    (repository.nomenclature$ | async)?.nomenclatureInfo
                      ?.englishSynonyms
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      (repository.nomenclature$ | async)?.kbNomenclatureInfo?.inKnowlengeBase ||
      (repository.nomenclature$ | async)?.hasExampleFile
    "
    class="my-32 grid-item grid grid-gutter-20"
  >
    <app-catalog-item-kb-button
      *ngIf="
        (repository.nomenclature$ | async)?.kbNomenclatureInfo?.inKnowlengeBase
      "
      [hxid]="(repository.nomenclature$ | async)?.hxid ?? ''"
      class="grid-item grid-md-6 grid-xs-12"
    ></app-catalog-item-kb-button>

    <app-example-file-button
      *ngIf="(repository.nomenclature$ | async)?.hasExampleFile"
      [hxid]="(repository.nomenclature$ | async)?.hxid ?? ''"
      class="grid-item grid-md-6 grid-xs-12"
    ></app-example-file-button>
  </div>

  <div
    *ngIf="(repository.nomenclature$ | async)?.geneticComplexInfoFile"
    class="grid-item"
  >
    <div class="grid grid-gutter-8 align-items-center">
      <div class="centered grid-item">
        <img [src]="iconSrc" alt="" />
      </div>

      <div class="grid-item">
        <a
          class="green-basic typography-underline typography"
          [href]="(repository.nomenclature$ | async)?.geneticComplexInfoFile"
          target="_blank"
        >
          Скачать информационный материал по генетическому комплексу
        </a>
      </div>
    </div>
  </div>

  <div *ngIf="(repository.nomenclature$ | async)?.deadline" class="grid-item">
    <div
      class="typography typography-h4 typography-medium typography-paragraph"
    >
      Срок выполнения
    </div>
    <div class="typography typography-headline">
      {{ (repository.nomenclature$ | async)?.deadline }}
    </div>
  </div>

  <div
    class="grid-item"
    *ngIf="(repository.nomenclature$ | async)?.explorationMethods?.length"
  >
    <div
      class="typography typography-h4 typography-medium typography-paragraph"
    >
      Методы
    </div>

    <div
      [ngSwitch]="
        (repository.nomenclature$ | async)?.explorationMethods?.length
      "
    >
      <div
        *ngSwitchCase="1"
        class="typography typography-headline grey-800 typography-paragraph"
      >
        {{ (repository.nomenclature$ | async)!.explorationMethods![0] }}
      </div>

      <ul
        *ngSwitchDefault
        class="typography typography-headline markerlist markerlist-check"
      >
        <li
          *ngFor="
            let method of (repository.nomenclature$ | async)?.explorationMethods
          "
        >
          {{ method }}
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="showBiomaterialTable$ | async" class="grid-item">
    <div class="typography typography-h4 typography-medium">
      Тип биоматериала
    </div>

    <div *ngIf="(repository.nomenclature$ | async)?.biomaterialRules">
      <ul class="typography typography-headline markerlist">
        <li
          *ngFor="
            let rule of (repository.nomenclature$
              | async)!.biomaterialRules?.slice(
              0,
              (visibleBiomaterials$ | async) ?? 0
            )
          "
        >
          {{ rule.biomaterialDescription }}
        </li>
      </ul>

      <div
        class="grid-item full-width"
        *ngIf="
          ((repository.nomenclature$ | async)?.biomaterialRules?.length ?? 0) >
          ((visibleBiomaterials$ | async) ?? 0)
        "
      >
        <div
          class="button button-subtle button-bordered full-width"
          (click)="setMaxVisibleBiomaterials()"
        >
          Показать все ↓
        </div>
      </div>
    </div>
  </div>
</div>
